import { useEffect, useRef } from 'react';
import { useUnsavedChangesContext } from '../contexts/UnsavedChangesContext';

export function useUnsavedChangesGuard(isDirty: boolean, saveHandler: () => Promise<void>) {
  const { register, unregister } = useUnsavedChangesContext();
  const saveRef = useRef(saveHandler);
  saveRef.current = saveHandler;

  useEffect(() => {
    register(isDirty, () => saveRef.current());
  }, [isDirty, register]);

  useEffect(() => {
    return () => {
      unregister();
    };
  }, [unregister]);

  // Handle browser tab close / hard refresh
  useEffect(() => {
    if (!isDirty) return;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isDirty]);
}
